import React from 'react';
import StatCard from './StatCard';
import { EquipmentI, EquipmentSimpleI } from '../../../../libs/interfaces';


interface StatsGridProps {
  equipments: EquipmentI[] | EquipmentSimpleI[];
}
const StatsGrid = ({ equipments }:StatsGridProps) => {


  const statsConfig = [
    {
      title: 'Total Activos',
      value: equipments?.length || 0,
      icon: '📦',
      // trend: { value: '+12%', direction: 'up' },
      variant: 'primary'
    },
    {
      title: 'Activos Operativos',
      value: equipments?.filter((el) => el.statusEquipment === 'OPERATIVO').length || 0,
      icon: '✅',
      // trend: { value: '+8%', direction: 'up' },
      variant: 'success'
    },
    {
      title: 'En Mantenimiento',
      value: equipments?.filter((el) => el.statusEquipment === 'EN REPARACIÓN').length || 0,
      icon: '🔧',
      // trend: { value: '+5%', direction: 'up' },
      variant: 'warning'
    },
    {
      title: 'Dañados',
      value: equipments?.filter((el) => el.statusEquipment === 'DAÑADO').length || 0,
      icon: '💀',
      // trend: { value: '-2%', direction: 'down' },
      variant: 'danger'
    },
     
  ];

  return (
    <div className="stats-grid">
      {statsConfig.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </div>
  );
};

export default StatsGrid;